<template>
  <div
    class="ps-card-list transition duration-500 ease-in-out h-screen flex items-stretch pointer-events-none ps-z-50"
    @click.stop
  >
    <div
      class="relative xl:container xl:rounded mx-auto mt-24 mb-24 w-full flex flex-col ps-bg-white ps-border-gray pointer-events-auto"
    >
      <div
        class="ps-bg-brand-orange ps-rounded-full ps-w-24 ps-h-24 ps-flex ps-items-center ps-justify-center ps-shadow-lg ps-text-white ps ps-bubble ps-bubble-delay-100 ps-absolute ps-top-0 ps-right-0 ps-mr-12 -mt-12 z-30"
      >
        <div class="ps-w-3/5">
          <svg-icon
            name="picnic-logo"
            class="ps-text-white"
            width="100%"
            height="auto"
            :fill="true"
          />
        </div>
      </div>
      <div class="flex-auto flex overflow-hidden">
        <!-- Off-canvas menu for mobile -->
        <div class="lg:hidden">
          <div v-if="isMobileMenuOpen" class="fixed inset-0 flex z-40">
            <transition
              enter-active-class="transition-opacity ease-linear duration-300"
              enter-class="opacity-0"
              enter-to-class="opacity-100"
              leave-active-class="transition-opacity ease-linear duration-300"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <div v-if="isMobileMenuOpen" class="fixed inset-0">
                <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
              </div>
            </transition>
            <!--
        Off-canvas menu, show/hide based on off-canvas menu state.

        Entering: "transition ease-in-out duration-300 transform"
          From: "-translate-x-full"
          To: "translate-x-0"
        Leaving: "transition ease-in-out duration-300 transform"
          From: "translate-x-0"
          To: "-translate-x-full"
      -->
            <transition
              enter-active-class="transition ease-in-out duration-300 transform"
              enter-class="-translate-x-full"
              enter-to-class="translate-x-0"
              leave-active-class="transition ease-in-out duration-300 transform"
              leave-class="translate-x-0"
              leave-to-class="-translate-x-full"
            >
              <div
                v-if="isMobileMenuOpen"
                class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white"
              >
                <div class="absolute top-0 right-0 -mr-14 p-1">
                  <button
                    class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
                    aria-label="Close sidebar"
                    @click="isMobileMenuOpen = false"
                  >
                    <svg
                      class="h-6 w-6 text-white"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
                <div class="mt-5 flex-1 h-0 overflow-y-auto">
                  <nav class="px-2">
                    <div class="space-y-1">
                      <a
                        href="#"
                        @click.prevent="routeCardsByPage"
                        :class="[
                          {
                            'outline-none bg-gray-100 hover:bg-white text-gray-900': isPage
                          }
                        ]"
                        class="group flex items-center px-2 py-2 text-base leading-5 font-medium rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:bg-gray-200 focus:outline-none transition ease-in-out duration-150"
                      >
                        <svg
                          class="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                          />
                        </svg>
                        Page
                      </a>
                      <a
                        href="#"
                        @click.prevent="routeCardsByProject"
                        :class="[
                          {
                            'outline-none bg-gray-100 hover:bg-white text-gray-900': isProject
                          }
                        ]"
                        class="group flex items-center px-2 py-2 text-base leading-5 font-medium rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition ease-in-out duration-150"
                      >
                        <svg
                          class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        Project
                      </a>

                      <a
                        href="#"
                        @click.prevent="routeCardsByCurrentUser"
                        :class="[
                          {
                            'outline-none bg-white hover:bg-white text-gray-900': isMyCards
                          }
                        ]"
                        class="group flex items-center px-2 py-2 text-base leading-5 font-medium rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition ease-in-out duration-150"
                      >
                        <svg
                          class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 6h16M4 10h16M4 14h16M4 18h16"
                          />
                        </svg>
                        My cards
                      </a>
                    </div>
                    <div class="mt-8">
                      <h3
                        class="px-3 text-xs leading-4 font-semibold text-gray-500 uppercase tracking-wider"
                        id="lists-headline"
                      >
                        Lists
                        <a
                          href="#"
                          v-if="
                            routeQuery &&
                              routeQuery.filter &&
                              routeQuery.filter.list_id
                          "
                          @click.prevent="filterByList(null)"
                          class="ml-3 font-normal text-blue-600"
                          >(Clear)</a
                        >
                      </h3>
                      <div
                        class="mt-1 space-y-1"
                        role="group"
                        aria-labelledby="lists-headline"
                      >
                        <a
                          v-for="(l, i) in lists"
                          :key="l.id"
                          href="#"
                          @click.prevent="filterByList(l.id)"
                          class="group flex items-center px-3 py-2 text-base leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
                        >
                          <span
                            :class="[getBgColor(i)]"
                            class="w-2.5 h-2.5 mr-4 ps-rounded-sm"
                          ></span>
                          <span class="truncate">
                            {{ l.name }}
                          </span>
                        </a>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </transition>

            <div class="flex-shrink-0 w-14">
              <!-- Dummy element to force sidebar to shrink to fit close icon -->
            </div>
          </div>
        </div>
        <!-- Static sidebar for desktop -->
        <div class="hidden lg:flex lg:flex-shrink-0">
          <div
            class="flex flex-col w-64 border-r border-gray-200 pt-5 pb-4 ps-bg-brand-brown-50"
          >
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="h-0 flex-1 flex flex-col overflow-y-auto">
              <!-- Sidebar Search -->
              <div class="px-3">
                <label for="search" class="sr-only">Search</label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      class="mr-3 h-4 w-4 text-gray-400"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <input
                    id="search"
                    class="form-input block w-full pl-9 sm:text-sm sm:leading-5"
                    placeholder="Search"
                  />
                </div>
              </div>
              <!-- Navigation -->
              <nav class="px-3 mt-6">
                <div class="space-y-1">
                  <a
                    href="#"
                    @click.prevent="routeCardsByPage"
                    :class="[
                      { 'outline-none bg-white hover:bg-white': isPage }
                    ]"
                    class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
                  >
                    <svg
                      class="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                      ></path>
                    </svg>
                    Page
                  </a>

                  <a
                    href="#"
                    @click.prevent="routeCardsByProject"
                    :class="[
                      { 'outline-none bg-white hover:bg-white': isProject }
                    ]"
                    class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
                  >
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      ></path>
                    </svg>
                    Project
                  </a>
                  <a
                    href="#"
                    @click.prevent="routeCardsByCurrentUser"
                    :class="[
                      { 'outline-none bg-white hover:bg-white': isMyCards }
                    ]"
                    class="group flex items-center px-2 py-2 text-sm leading-5 font-medium rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
                  >
                    <svg
                      class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 6h16M4 10h16M4 14h16M4 18h16"
                      />
                    </svg>
                    My cards
                  </a>
                </div>

                <div class="mt-8">
                  <!-- Secondary navigation -->
                  <h3
                    class="px-3 text-xs leading-4 font-semibold text-gray-500 uppercase tracking-wider"
                    id="lists-headline"
                  >
                    Lists
                    <a
                      href="#"
                      v-if="
                        routeQuery &&
                          routeQuery.filter &&
                          routeQuery.filter.list_id
                      "
                      @click.prevent="filterByList(null)"
                      class="ml-3 font-normal text-blue-600"
                      >(Clear)</a
                    >
                  </h3>
                  <div
                    class="mt-1 space-y-1"
                    role="group"
                    aria-labelledby="lists-headline"
                  >
                    <a
                      v-for="(l, i) in lists"
                      :key="l.id"
                      @click.prevent="filterByList(l.id)"
                      href="#"
                      class="group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-700 rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition ease-in-out duration-150"
                    >
                      <span
                        :class="[getBgColor(i)]"
                        class="w-2.5 h-2.5 mr-4 ps-rounded-sm"
                      ></span>
                      <span class="truncate">
                        {{ l.name }}
                      </span>
                    </a>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <!-- Main column -->
        <div class="flex flex-col w-0 flex-1 overflow-hidden">
          <!-- Search header -->
          <div
            class="relative z-10 flex-shrink-0 flex h-16 bg-white border-b border-gray-200 lg:hidden"
          >
            <!-- Sidebar toggle, controls the 'sidebarOpen' sidebar state. -->
            <button
              class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 lg:hidden"
              aria-label="Open sidebar"
              @click="isMobileMenuOpen = true"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M4 6h16M4 12h8m-8 6h16" />
              </svg>
            </button>
            <div class="flex-1 flex justify-between px-4 sm:px-6 lg:px-8">
              <div class="flex-1 flex opacity-25"></div>
              <div class="flex items-center"></div>
            </div>
          </div>
          <main
            class="flex-1 relative z-0 overflow-y-auto focus:outline-none"
            tabindex="0"
          >
            <!-- Page title & actions -->
            <div
              class="border-b border-gray-200 px-4 py-6 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8"
            >
              <div class="flex-1 min-w-0">
                <h1
                  class="text-lg font-medium leading-6 text-gray-900 sm:truncate"
                >
                  {{ cardHeader }}
                </h1>
              </div>
            </div>

            <!-- Projects list (only on smallest breakpoint) -->
            <div class="mt-10 sm:hidden">
              <div class="px-4 sm:px-6">
                <h2
                  class="text-gray-500 text-xs font-medium uppercase tracking-wide"
                >
                  Cards
                </h2>
              </div>
              <ul
                class="mt-3 border-t border-gray-200 divide-y divide-gray-100"
              >
                <li v-if="isLoading">
                  <div class="flex items-center space-x-3 lg:pl-2">
                    <span
                      class="flex-shrink-0 h-4 w-4 rounded-full flex items-center justify-center"
                    >
                      <span class="h-2 w-2 rounded-full bg-gray-400"></span>
                    </span>

                    <a href.prevent="#" class="truncate hover:text-gray-600">
                      <span>0 Results </span>
                    </a>
                    <span class="inline-block w-6 h-6"></span>
                  </div>
                </li>
                <item-card-list
                  v-for="d in dots"
                  :key="d.id"
                  :dot="d"
                  :is-on-page="isOnPage(d.pages)"
                  :is-assigned-to-current-user="
                    isAssignedToCurrentUser(d.card.assigned_to_user_id)
                  "
                  @click="routeToCard"
                />
              </ul>
            </div>
            <!-- Projects table (small breakpoint and up) -->
            <div class="hidden sm:block">
              <div
                class="align-middle inline-block min-w-full border-b border-gray-200"
              >
                <table class="min-w-full">
                  <thead>
                    <tr class="">
                      <th
                        class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <span class="lg:pl-2">Card</span>
                      </th>
                      <th
                        class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        People
                      </th>
                      <th
                        class="hidden md:table-cell px-6 py-3 border-b border-gray-200 bg-gray-50 text-right text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Created
                      </th>
                      <th
                        class="pr-6 py-3 border-b border-gray-200 bg-gray-50 text-right text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                      ></th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-100">
                    <tr v-if="isLoading">
                      <td class="ps-border-0 text-left">
                        <div v-if="isLoading" class="w-24 ps-py-3 ps-pl-4">
                          <loading-spinner
                            :size="2"
                            bg-color="brand-brown-200"
                          />
                        </div>
                      </td>
                    </tr>
                    <template v-else-if="dots.length">
                      <item-card-table
                        v-for="d in dots"
                        :key="d.id"
                        :dot="d"
                        :is-on-page="isOnPage(d.pages)"
                        :is-assigned-to-current-user="
                          isAssignedToCurrentUser(d.card.assigned_to_user_id)
                        "
                        @click="routeToCard"
                      />
                    </template>
                    <tr v-else>
                      <td
                        class="px-6 py-3 max-w-0 w-full whitespace-no-wrap text-sm leading-5 font-medium text-gray-400"
                      >
                        <div class="flex items-center space-x-3 lg:pl-2">
                          <span
                            class="flex-shrink-0 h-4 w-4 rounded-full flex items-center justify-center"
                          >
                            <span
                              class="h-2 w-2 rounded-full bg-gray-400"
                            ></span>
                          </span>

                          <a
                            href.prevent="#"
                            class="truncate hover:text-gray-600"
                          >
                            <span>0 Results </span>
                          </a>
                          <span class="inline-block w-6 h-6"></span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </main>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>

<script lang="javascript">
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState
} from '@picnic-software/vuex'

import LoadingSpinner from '@/components/LoadingSpinner'
import ItemCardTable from '@/components/items/ItemCardTable'
import ItemCardList from '@/components/items/ItemCardList'
import TheFooter from '@/components/TheFooter'

import { ROUTE_LIST_PROJECT, ROUTE_LIST_PAGE, ROUTE_LIST_CURRENT_USER } from '@/common/constants'

const bgColors = [
        'bg-indigo-500',
        'bg-teal-400',
        'bg-orange-500',
        'bg-pink-500'
      ]

export default {
  name: 'CardList',
  props: {
    msg: String
  },
  components: {
    ItemCardTable,
    ItemCardList,
    LoadingSpinner,
    TheFooter
  },
  data() {
    return {
      isLoading: false,
      isMobileMenuOpen: false,
      dots: [],
    }
  },
  computed: {
    ...mapState({
      pageId: state => state.pages.active.id,
      projectId: state => state.provider.projects.active.id,
      route: state => state.router.active,
      routeQuery: state => state.router.query,
      currentUser: state => state.auth.user,
      lists: state => state.provider.lists.all
    }),
    ...mapGetters({
      routerMatches: 'router/matches',
      routerMatchesExact: 'router/matchesExact',
      dotsAssignedPageCount: 'pages/dots/count',
      dotsAssigneProjectCount: 'dots/count',
      isModeSite: 'app/isModeSite'
    }),

    isProject() {
      return this.routerMatchesExact(ROUTE_LIST_PROJECT)
    },
    isPage() {
      return this.routerMatchesExact(ROUTE_LIST_PAGE)
    },
    isMyCards() {
      return this.routerMatchesExact(ROUTE_LIST_CURRENT_USER)
    },
    cardHeader() {
      if (this.isProject) {
        return 'Card(s) in Project'
      }
      if (this.isPage) {
        return 'Card(s) on this page'
      }
      if (this.isMyCards) {
        return 'My Card(s) in project'
      }
    }
  },
  watch: {
    routeQuery(val) {
      if (this.route.startsWith('ROUTE_LIST')) {
        this.find()
      }
    }
  },
  async mounted() {
    await this.findLists()
  },
  methods: {
    ...mapActions({
      findDots: 'dots/find',
      routerCard: 'router/card',
      findLists: 'provider/lists/find'
    }),
    ...mapMutations({
      routerTo: 'router/to',
      routerToWithQuery: 'router/toWithQuery',
      routerControls: 'router/controls'
    }),
    async find() {
      this.isLoading = true
      console.log('FIND THOSE DOTS')
      this.dots = await this.findDots(this.routeQuery)
      await this.$nextTick()
      this.isLoading = false
    },
    tabIsActive(slug) {
      return this.routerMatches(slug)
    },
    async scrollToEnd() {
      if (this.$refs.scroller) {
        await this.$nextTick()
        this.$refs.scroller.scrollTop = this.$refs.scroller.scrollHeight
      }
    },

    isAssignedToCurrentUser(assigntedToUserId) {
      return assigntedToUserId === this.currentUser.id
    },
    isOnPage(pages) {
      if (pages && pages.length) {
        return pages.includes(this.pageId)
      }
      return false
    },
    getBgColor(i) {

     return bgColors[i]

    },
    routeCardsByProject() {
      return this.routerToWithQuery({
        route: ROUTE_LIST_PROJECT,
        query: {
          provider_project_id: this.projectId
        }
      })
    },
    routeCardsByPage() {
      console.log('route cards by page')
      return this.routerToWithQuery({
        route: ROUTE_LIST_PAGE,
        query: {
          page_id: this.pageId,
          provider_project_id: this.projectId
        }
      })
    },
    routeCardsByCurrentUser() {
      return this.routerToWithQuery({
        route: ROUTE_LIST_CURRENT_USER,
        query: {
          provider_user_id: this.currentUser.provider_user_id,
          provider_project_id: this.projectId
        }
      })
    },
    routeToCard(dotId) {
      return this.routerCard({id: dotId})
    },
    filterByList(listId) {
      return this.routerToWithQuery({
        query: {
          ...this.routeQuery,
          filter: {
            list_id: listId
          }
        }
      })
    },
  }
}
</script>

<style lang="postcss">
.ps-card-list {
  transform: translateY(105%);
}
.ps-card-list.ps-is-active {
  transform: translateY(0);
}
</style>
